import React, { useState, useEffect } from 'react';

import { useInView } from 'react-intersection-observer';

import jet from "@randajan/jet-core";


import "./Rating.scss";
import { Img } from '@randajan/jet-react/dom/img';

export const Rating = ()=>{
  const [ref, inView] = useInView({triggerOnce:true, threshold: .8});

  return (
    <div ref={ref} className={jet.melt(["Rating", inView ? "inview" : ""], " ")}>
      <Img src="icons/itcan/diamond.svg"/>
      <Img src="icons/itcan/diamond.svg"/>
      <Img src="icons/itcan/diamond.svg"/>
      <Img src="icons/itcan/diamond.svg"/>
      <Img src="icons/itcan/diamond.svg"/>
    </div>
  )
}